import React, { useState, useEffect } from 'react'
import { Input, Table, Row, Col, Select, Pagination, Radio, Checkbox } from "antd";
import backButton from '../../assets/images/back_button_arrow.svg';
import demandIcon from '../../assets/images/icons/demand_icon.svg';
import addIcon from '../../assets/images/addbtnicon/plusicon.svg';
import { Link } from "react-router-dom";
import prevIcon from '../../assets/images/icons/chevron-left.svg';
import nextIcon from '../../assets/images/icons/chevron-right.svg';
import EditIcon from '../../assets/images/icons/edit.svg';
import DeleteIcon from '../../assets/images/icons/delete_icon.svg';
import configData from "../../config/config.json";
import deleteIcon from '../../assets/images/icons/delete_icon.svg';



import axios from "axios";
function resetFormView() { };

const { TextArea } = Input;

const data = [
    {
        key: '1',
        name: 'action',
        age: 32,
        address: '10 Downing Street',
    },
    {
        key: '2',
        name: 'id',
        age: 42,
        address: '10 Downing Street',
    },
    {
        key: '3',
        name: 'sspslist',
        age: 42,
        address: '10 Downing Street',
    },
    {
        key: '4',
        name: 'sspslist',
        age: 42,
        address: '10 Downing Street',
    },
];

const SecondForm = ({ handlePageViewChange }) => {

    const [selectedRowKeys, setSelectedRowKeys] = useState([]); // To track selected rows

    const onSelectChange = (selectedRowKeys) => {
        setSelectedRowKeys(selectedRowKeys);
    };

    // Determine if "Select All" checkbox should be checked or indeterminate
    const isIndeterminate = selectedRowKeys.length > 0 && selectedRowKeys.length < data.length;
    const isCheckAll = selectedRowKeys.length === data.length;


    const columns = [
        {
            title: (
                <Checkbox
                    className='table_checkbox_d2'
                    indeterminate={isIndeterminate}
                    checked={isCheckAll}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        const allKeys = data.map((record) => record.key); // Assuming each data item has a unique `key`
                        setSelectedRowKeys(checked ? allKeys : []);
                    }}
                />
            ),
            dataIndex: 'checkbox',
            width: 30,
            fixed: 'left',
            render: (text, record) => (
                <Checkbox
                    className='table_checkbox_d2'
                    checked={selectedRowKeys.includes(record.key)}
                    onChange={(e) => {
                        const checked = e.target.checked;
                        if (checked) {
                            setSelectedRowKeys([...selectedRowKeys, record.key]);
                        } else {
                            setSelectedRowKeys(selectedRowKeys.filter((key) => key !== record.key));
                        }
                    }}
                />
            ),
        },
        {
            title: '',
            dataIndex: 'action',
            width: 30,
            render: (text, record) => {
                return (
                    <div className='btn_group'>
                        <button className='download_icon download_icon_d2'>
                            <img src={EditIcon} alt='USP' />
                        </button>
                    </div >
                )
            },
        },
        {
            title: 'ID',
            dataIndex: 'id',
            sorter: true,
            render: () => <div className="text_dark_800">221530</div>,
        },
        {
            title: 'Name',
            dataIndex: 'name',
            render: () => <div className="text_dark">Bidcube-TH-IA-Banner-225100</div>,
        },
        {
            title: 'SSPs list',
            dataIndex: 'sspslist',
            render: () => <div className="text_dark">None</div>,
        },
    ];

    const onChange = (value) => {
        console.log(`selected ${value}`);
    };
    const onSearch = (value) => {
        console.log('search:', value);
    };

    const onChangedate = (date, dateString) => {
        console.log(date, dateString);
    };
    const handleChange = (page) => {
        setCurrent(page);
    };
    const [search, setSearch] = useState("");
    const [filteredData, setFilteredData] = useState(data);
    const [loading, setLoading] = useState(true);

    // Pagination
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(20);
    const totalItems = data.length;

    const itemRender = (current, type, originalElement) => {
        if (type === 'prev') {
            return <Link><img src={prevIcon} alt='USP' /></Link>;
        }
        if (type === 'next') {
            return <Link><img src={nextIcon} alt='USP' /></Link>;
        }
        return originalElement;
    };

    const startItem = (current - 1) * pageSize + 1;
    const endItem = Math.min(current * pageSize, totalItems);
    const paginationProps = {
        current,
        pageSize,
        total: totalItems,
        onChange: handleChange,
        showSizeChanger: false, // Disable default size changer
        itemRender: itemRender, // Add custom itemRender function
    };


    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "remotefeed/feedTypeList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // setFeedListRepeaterOptions(response.data.data)
                setFeedListRepeaterOptions([{ label: 'Pubmatic DSP(887)', value: '887' }, { label: 'Pubmatic DSP(888)', value: '888' }, { label: 'Pubmatic DSP(889)', value: '889' }, { label: 'Pubmatic DSP(900)', value: '900' }, { label: 'Pubmatic DSP(901)', value: '901' }])
            })
            .catch((error) => { });

        // setFeedListRepeater(prevFeedListRepeater =>
        //     prevFeedListRepeater.map(item => ({
        //         ...item,
        //         validation_feed_provider_id: false, // Add this key with value false
        //         validation_remote_id: false // Add this key with value false
        //     }))
        // );

    }, [])

    // --------------------------------------------------------------------------------------------------------------------------------//

    const [feedListRepeaterOptions, setFeedListRepeaterOptions] = useState([])
    const [feedListRepeater, setFeedListRepeater] = useState([

    ]);


    const handleChangeFeedProviderId = (e, index) => {
        const listTrigger = [...feedListRepeater];
        listTrigger[index]["feed_provider_id"] = e;
        listTrigger[index]["validation_feed_provider_id"] = false;
        setFeedListRepeater(listTrigger);
    };

    const handleChangeRemoteId = (e, index) => {
        const listTrigger = [...feedListRepeater];
        if (/^[\d\W]*$/.test(e.target.value.trim())) {

            listTrigger[index]["remote_id"] = e.target.value.trim();
            if (e.target.value.trim().length === 0) {
                listTrigger[index]["validation_remote_id"] = true;
            }
            else {
                listTrigger[index]["validation_remote_id"] = false;
            }
            setFeedListRepeater(listTrigger);
        }

    };

    const handleRemoveFeedListRepeater = (index) => {
        let listTrigger = [...feedListRepeater];
        listTrigger.splice(index, 1);
        setFeedListRepeater(listTrigger);
    };

    const handleAddFeedListRepeater = () => {
        setFeedListRepeater([
            ...feedListRepeater,
            {
                feed_provider_id: "",
                remote_id: "",
                validation_feed_provider_id: false,
                validation_remote_id: false
            },
        ]);
    };
    const validateFeedListRepeater = () => {
        setFeedListRepeater(prevFeedListRepeater =>
            prevFeedListRepeater.map(item => {
                const isFeedProviderIdEmpty = item.feed_provider_id === "";
                const isRemoteIdEmpty = item.remote_id === "";

                return {
                    ...item,
                    validation_feed_provider_id: isFeedProviderIdEmpty, // Set to true if feed_provider_id is empty
                    validation_remote_id: isRemoteIdEmpty // Set to true if remote_id is empty
                };
            })
        );

        // Return true if all fields are filled, false if any are empty
        return feedListRepeater.every(item => item.feed_provider_id !== "" && item.remote_id !== "");
    };


    return (
        <>
            <div className="container_box--wrapper pt_header">
                <div className="container_box--breadcrumb">
                    <ul className="container_box--breadcrumb-list">
                        <li>
                            <Link onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }}>
                                <img src={demandIcon} alt="USP" /> GAM
                            </Link>
                        </li>
                        <li>Campaign</li>
                        <li className="primary">New Campaign</li>
                    </ul>
                </div>
                <div className="container_box--wrapper--title d_flex justify-content-between align-items-center">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table")
                                resetFormView()
                            }} />
                        <h1 className="heading"> Create Campaign </h1>
                    </div>
                    <div className='li_tabs_designs'>
                        <ul>
                            <li className='active_li_tab completed_li_tab'>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 5.625V6.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 13.125V14.375" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.125 13.125H10.9375C11.3519 13.125 11.7493 12.9604 12.0424 12.6674C12.3354 12.3743 12.5 11.9769 12.5 11.5625C12.5 11.1481 12.3354 10.7507 12.0424 10.4576C11.7493 10.1646 11.3519 10 10.9375 10H9.0625C8.6481 10 8.25067 9.83538 7.95765 9.54235C7.66462 9.24933 7.5 8.8519 7.5 8.4375C7.5 8.0231 7.66462 7.62567 7.95765 7.33265C8.25067 7.03962 8.6481 6.875 9.0625 6.875H11.875" stroke="#7434DB" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Budget
                            </li>
                            <li className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M1.875 14.375V12.5859C1.875 8.09375 5.48437 4.39062 9.96875 4.375C11.0384 4.37089 12.0983 4.57801 13.0877 4.98449C14.077 5.39096 14.9764 5.98879 15.7342 6.74368C16.492 7.49857 17.0933 8.39565 17.5035 9.38346C17.9138 10.3713 18.125 11.4304 18.125 12.5V14.375C18.125 14.5408 18.0592 14.6997 17.9419 14.8169C17.8247 14.9342 17.6658 15 17.5 15H2.5C2.33424 15 2.17527 14.9342 2.05806 14.8169C1.94085 14.6997 1.875 14.5408 1.875 14.375Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 4.375V6.875" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M2.14844 10.3984L4.57031 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M17.8516 10.3984L15.4297 11.0469" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M8.07812 15L13.4219 8.03906" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Optimization
                            </li>
                            <li className=''>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85787 14.1421 2.5 10 2.5C5.85787 2.5 2.5 5.85787 2.5 10C2.5 14.1421 5.85787 17.5 10 17.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10.002 14.5C12.4872 14.5 14.502 12.4853 14.502 10C14.502 7.51472 12.4872 5.5 10.002 5.5C7.51667 5.5 5.50195 7.51472 5.50195 10C5.50195 12.4853 7.51667 14.5 10.002 14.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 11.5C10.8284 11.5 11.5 10.8284 11.5 10C11.5 9.17157 10.8284 8.5 10 8.5C9.17157 8.5 8.5 9.17157 8.5 10C8.5 10.8284 9.17157 11.5 10 11.5Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Targeting
                            </li>
                            {/* <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M2 3.73383V8.43381H6.69998" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M3.96616 12.3505C4.47406 13.7921 5.43673 15.0296 6.70911 15.8765C7.98149 16.7235 9.49465 17.1339 11.0206 17.0461C12.5466 16.9583 14.0026 16.3769 15.1694 15.3896C16.3362 14.4023 17.1506 13.0625 17.4897 11.5721C17.8289 10.0817 17.6745 8.52151 17.0498 7.12651C16.4251 5.73151 15.364 4.57732 14.0263 3.83783C12.6886 3.09834 11.1469 2.81363 9.6333 3.02658C8.11973 3.23953 6.71636 3.93861 5.63465 5.01849L2 8.43381" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Retargeting
                            </li> */}
                            <li>
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M15.4444 3H4.55556C3.69645 3 3 3.69645 3 4.55556V15.4444C3 16.3036 3.69645 17 4.55556 17H15.4444C16.3036 17 17 16.3036 17 15.4444V4.55556C17 3.69645 16.3036 3 15.4444 3Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M7.27799 8.44444C7.92233 8.44444 8.44466 7.92211 8.44466 7.27778C8.44466 6.63345 7.92233 6.11111 7.27799 6.11111C6.63366 6.11111 6.11133 6.63345 6.11133 7.27778C6.11133 7.92211 6.63366 8.44444 7.27799 8.44444Z" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M16.9991 12.3333L13.1102 8.44444L4.55469 17" stroke="#667085" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                Ads
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="container_box--content pt_20 form_scrollable_div_d2">
                    <div className="container_box--width">
                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Ad</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <div className="form_content_block--group">
                                        <Radio.Group className="form_radio two_radio_box_design_d2">
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <label className="form_label ">
                                                        Multiple units per page
                                                    </label>
                                                    <Radio className="radio_btn" value="Website">
                                                        Show all ads per publish page
                                                    </Radio>
                                                </Col>
                                                <Col span={12}>
                                                    <label className="form_label invisible">
                                                        Multiple units per page
                                                    </label>
                                                    <Radio className="radio_btn" value="Inapp">
                                                        One ad per publisher page
                                                    </Radio>
                                                </Col>
                                            </Row>
                                        </Radio.Group>
                                    </div>
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Creative rotation </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder=""
                                                    optionFilterProp="label"
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <Row gutter={16}>
                                                <Col span={12}>
                                                    <div className="form_content_block--group suffix_d2">
                                                        <label className="form_label">Min. bidding interval per unique IP, ms </label>
                                                        <Input className='form_control form_control_with_icon_d2 basic ' placeholder='' autocomplete="off" />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group suffix_d2">
                                                        <label className="form_label">Max clicks per user id </label>
                                                        <Input className='form_control form_control_with_icon_d2 basic ' placeholder='' autocomplete="off" />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="form_content_block--group suffix_d2 mb-0">
                                                <label className="form_label">Min viewability * </label>
                                                <Input className='form_control form_control_with_icon_d2 basic ' placeholder='0' suffix={'%'} autocomplete="off" />
                                                <span className="error_content"> </span>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        {/* this code for table */}
                        {/* <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Exchanges Mapping</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <div className="d_flex justify_content_between mb_10">
                                        <div className="form_content_block--group mb-0">
                                            <Input
                                                type='text'
                                                className='form_control basic md search_input w_table_search'
                                                placeholder="Search"
                                                value={search}
                                                onChange={(e) => {

                                                    if (e.target.value.trim().length === 0) {
                                                        setLoading(true)
                                                    }

                                                    setSearch(e.target.value)
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="table_content--box">
                                        <Table columns={columns}
                                            pageSize={100}
                                            dataSource={filteredData.slice((current - 1) * pageSize, current * pageSize)}
                                            onChange={onChange}
                                            pagination={false}
                                            scroll={{ x: 'max-Content', y: 'calc(100vh - 32rem' }} />
                                        <Row className="custom_pagination--container">
                                            <Col span={12}>
                                                <span className="custom_pagination--total-text justify-content-start">
                                                    {`${startItem}-${endItem} of ${totalItems} items`}
                                                </span>
                                            </Col>
                                            <Col span={12}>
                                                <Pagination {...paginationProps} className="custom_pagination" />
                                            </Col>
                                        </Row>

                                    </div>
                                </div>
                            </Col>
                        </Row> */}

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Frequency Capping</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <Row gutter={16}>
                                                <Col span={8}>
                                                    <div className="form_content_block--group mb-0">
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder=""
                                                            value='Device ID - Based'
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="form_content_block--group mb-0">
                                                        <Select
                                                            showSearch
                                                            value='per hour'
                                                            className='form_select basic no_search'
                                                            placeholder=""
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                                <Col span={8}>
                                                    <div className="form_content_block--group mb-0">
                                                        <Input className='form_control basic' placeholder='0' autocomplete="off" />
                                                        <span className="error_content"> </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <div className="container_box--label-info">
                                    <label>Conversion Details</label>
                                </div>
                            </Col>

                            <Col span={16}>
                                <div className="container_box--form-container">
                                    <Row gutter={16}>
                                        <Col span={24}>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Bid optimization mode </label>
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder=""
                                                    optionFilterProp="label"
                                                    value='Bid Floor + % Margin'
                                                    onChange={onChange}
                                                    onSearch={onSearch}
                                                    options={[
                                                        {
                                                            value: 'jack',
                                                            label: 'Jack',
                                                        },
                                                        {
                                                            value: 'lucy',
                                                            label: 'Lucy',
                                                        },
                                                        {
                                                            value: 'tom',
                                                            label: 'Tom',
                                                        },
                                                    ]}
                                                />
                                                <span className="error_content"> </span>
                                            </div>
                                            <Row gutter={16} className='position-relative'>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">VCR (Min-Max)</label>
                                                        <Input className='form_control basic' placeholder='Min' autocomplete="off" />
                                                    </div>
                                                    <span className="error_content"></span>
                                                    <small className='line_between_cols_d2 translateY'>-</small>
                                                </Col>
                                                <Col span={12}>
                                                    <div className="form_content_block--group">
                                                        <label className="form_label invisible">VCR (Min-Max)</label>
                                                        <Input className='form_control basic' placeholder='Max' autocomplete="off" />
                                                        <span className="error_content"></span>
                                                    </div>
                                                </Col>
                                            </Row>
                                            <div className="form_content_block--group mb-0">
                                                <div className="primary_checkbox">
                                                    <Checkbox id="zone_checkbox_prebid" name="zone_checkbox_prebid">
                                                        <span className="form_label">
                                                            IP-based View-through Conversion for CTV devices
                                                        </span>
                                                    </Checkbox>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="hr_custom mb_20"></div>
                    <div className="btn_group justify-content-end gap_8 pb_50">
                        <button className="w_120_d2 btn btn_white_outline w_fit_content"> Back </button>
                        <button className="w_120_d2 btn btn_primary w_fit_content">Next</button>
                    </div>
                </div >
            </div >
        </>
    )
}

export default SecondForm
